module.exports = __webpack_public_path__ + "img/66.65bdf218.jpg";